import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styles from "./policy_info_modal.module.css";
import { BookingDataContext } from "containers/data_context";

import getHotelPolicyText from "utils/get_hotel_policy_text";

import PolicyInfoSection from "./policy_info_section";
export default function PrivacyPolicyInfoModal({ show, onHide }) {
  const { property } = useContext(BookingDataContext);
  const { t } = useTranslation();

  const { data: propertyData } = property;

  const hotelPolicyText = getHotelPolicyText(propertyData?.hotelPolicy);

  return (
    <Modal dialogClassName={styles.modal} show={show} onHide={onHide}>
      <Modal.Dialog className={styles.modal}>
        <Modal.Header dialogClassName={styles.modalheder} closeButton>
          <h6 className={styles.header}>Privacy Policies</h6>
        </Modal.Header>
        <Modal.Body>
          <PolicyInfoSection
            title={t("payment_page:privacy_policy_info:hotel_policy")}
            text={hotelPolicyText}
          />
        </Modal.Body>
      </Modal.Dialog>
    </Modal>
  );
}
